import { ContainerModule } from 'inversify';
import 'reflect-metadata';

import { TournamentLeaderboardRepository } from 'domain/repositories/ITournamentLeaderboardRepository';
import { TournamentLocationsRepository } from 'domain/repositories/ITournamentLocationsRepository';
import { TournamentsRepository } from 'domain/repositories/ITournamentsRepository';

import { useTournamentLeaderboardRepository } from './providers/tournament/useTournamentLeaderboardRepository';
import { useTournamentLocationsRepository } from './providers/tournament/useTournamentLocationsRepository';
import { useTournamentsRepository } from './providers/tournament/useTournamentsRepository';

export const infrastructureModule = new ContainerModule((bind) => {
  bind(TournamentLocationsRepository).toFunction(useTournamentLocationsRepository);
  bind(TournamentsRepository).toFunction(useTournamentsRepository);
  bind(TournamentLeaderboardRepository).toFunction(useTournamentLeaderboardRepository);
});
